import {
  FunctionsFetchError,
  FunctionsHttpError,
  FunctionsRelayError,
} from "@supabase/supabase-js";

export const numberToLocale = (
  value: number,
  locale: string = defaultCurrency.locale,
  currency: string = defaultCurrency.currency,
) => {
  return value?.toLocaleString(locale, {
    style: "currency",
    currency: currency,
  });
};

export const numberToFixed = ({
  value,
  fixed,
}: {
  value: number;
  fixed: number;
}) => {
  return value % 1 == 0 ? value : value.toFixed(fixed);
};

export const formatAmountWithSymbol = ({
  value,
  fixed,
  symbol
}: {
  value: number;
  fixed: number;
  symbol: string;
}) => {
  const formatted = value.toLocaleString("en-US", {
    minimumFractionDigits: fixed,
    maximumFractionDigits: fixed,
  });

  return `${symbol} ${formatted}`;
};

export const defaultCurrency = {
  locale: "en-US",
  currency: "EUR",
  symbol: "€",
};

export const getErrorByInvoke = async (
  error: any,
): Promise<{
  errorData: any;
  errorMessage: string;
}> => {
  if (error instanceof FunctionsHttpError) {
    const errorData = await error.context.json();
    const errorMessage = errorData.error.body.errors[0].message;
    return { errorData, errorMessage };
  } else if (error instanceof FunctionsRelayError) {
    return {
      errorData: "Relay error",
      errorMessage: error.message,
    };
  } else if (error instanceof FunctionsFetchError) {
    return {
      errorData: "Fetch error",
      errorMessage: error.message,
    };
  } else {
    return {
      errorData: "Unknown error",
      errorMessage: "An unexpected error occurred",
    };
  }
};
